export default __webpack_public_path__ + "static/media/messenger-sponsored-messages.3b5ee6d3.jpg";